const API_URI = 'https://api.honda-dream-japan.co.jp'

const Util = {
  // API URL
  API: {
    products: `${API_URI}/products`,
    productNames: `${API_URI}/product-names`,
    estimateList: `${API_URI}/estimate/products.json`,
    estimateDetails: `${API_URI}/estimate/products`,
  },
  // 消費税率
  TAX: 1.1,
  // バイク種別 ID
  TYPE_ID: {
    new: 1,
    used: 2,
    test: 3,
    unused: 4,
  },
  // バイク種別 ラベル
  TYPE_LABEL: {
    new: '新車',
    used: '中古車',
    test: '試乗車',
    unused: '中古車',
  },
  // 検索表示数
  SEARCH_LIMIT: 20,
  // 排気量
  DISPLACEMENT: [
    { value: '', label: '排気量を選択してください', from: 0, to: 0 },
    { value: '50', label: '50cc以下', from: 0, to: 50 },
    { value: '51-125', label: '51cc～125cc', from: 51, to: 125 },
    { value: '126-250', label: '126cc～250cc', from: 126, to: 250 },
    { value: '251-400', label: '251cc～400cc', from: 251, to: 400 },
    { value: '401-750', label: '401cc～750cc', from: 401, to: 750 },
    { value: '751-1000', label: '751cc～1000cc', from: 751, to: 1000 },
    { value: '1001', label: '1001cc以上', from: 1001, to: 99999 },
  ],
  // 排気量（未使用車用）
  DISPLACEMENT_UNUSED: [
    { value: '', label: '排気量を選択してください', from: 0, to: 0 },
    { value: '126-250', label: '126cc～250cc', from: 126, to: 250 },
    { value: '251-400', label: '251cc～400cc', from: 251, to: 400 },
    { value: '401-750', label: '401cc～750cc', from: 401, to: 750 },
    { value: '751-1000', label: '751cc～1000cc', from: 751, to: 1000 },
    { value: '1001', label: '1001cc以上', from: 1001, to: 99999 },
  ],
  // 走行距離
  MILEAGE: [
    { value: '', label: '走行距離を選択してください', from: 0, to: 0 },
    { value: '1000', label: '1000km以下', from: 0, to: 1000 },
    { value: '1000-5000', label: '1000～5000km', from: 1000, to: 5000 },
    { value: '5000-10000', label: '5000～10000km', from: 5000, to: 10000 },
    { value: '10000-15000', label: '10000～15000km', from: 10000, to: 15000 },
    { value: '15000', label: '15000km以上', from: 15000, to: 99999 },
  ],
  // 店舗マスタ
  DEALER: {
    area: [
      {
        name: '東北エリア',
        all: '',
        allVal: '0all',
        shops: [
          {
            shop_id: 275,
            id: 3,
            name: 'ホンダドリーム 盛岡',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
          {
            shop_id: 283,
            id: 2,
            name: 'ホンダドリーム 仙台泉',
            expenses_pdf: 'east-japan_designated-factory.pdf',
            expenses_image: 'east-japan_designated-factory.png',
          },
          {
            shop_id: 288,
            id: 4,
            name: 'ホンダドリーム 宮城岩沼',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
          {
            shop_id: 308,
            id: 1,
            name: 'ホンダドリーム 郡山',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
        ],
      },
      {
        name: '関東エリア',
        all: '',
        allVal: '1all',
        shops: [
          {
            shop_id: 312,
            id: 65,
            name: 'ホンダドリーム 水戸北',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
          {
            shop_id: 244,
            id: 67,
            name: 'ホンダドリーム ふかや花園',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
          {
            shop_id: 338,
            id: 56,
            name: 'ホンダドリーム 鴻巣',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
          {
            shop_id: 347,
            id: 57,
            name: 'ホンダドリーム 所沢',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
          {
            shop_id: 356,
            id: 58,
            name: 'ホンダドリーム 大宮',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
          {
            shop_id: 361,
            id: 59,
            name: 'ホンダドリーム 狭山',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
          {
            shop_id: 317,
            id: 60,
            name: 'ホンダドリーム 船橋',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
          {
            shop_id: 321,
            id: 62,
            name: 'ホンダドリーム 松戸',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
          {
            shop_id: 366,
            id: 61,
            name: 'ホンダドリーム 東浦和',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
          {
            shop_id: 330,
            id: 63,
            name: 'ホンダドリーム 蘇我',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
          {
            shop_id: 370,
            id: 64,
            name: 'ホンダドリーム 草加',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
          {
            shop_id: 377,
            id: 66,
            name: 'ホンダドリーム 新座',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
          {
            shop_id: 10,
            id: 29,
            name: 'ホンダドリーム 世田谷',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
          {
            shop_id: 382,
            id: 30,
            name: 'ホンダドリーム 西東京',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
          {
            shop_id: 391,
            id: 34,
            name: 'ホンダドリーム 練馬',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
          {
            shop_id: 419,
            id: 35,
            name: 'ホンダドリーム 板橋',
            expenses_pdf: 'east-japan_designated-factory.pdf',
            expenses_image: 'east-japan_designated-factory.png',
          },
          {
            shop_id: 432,
            id: 36,
            name: 'ホンダドリーム 葛飾',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
          {
            shop_id: 439,
            id: 37,
            name: 'ホンダドリーム 大田',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
          {
            shop_id: 448,
            id: 40,
            name: 'ホンダドリーム 立川',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
          {
            shop_id: 461,
            id: 31,
            name: 'ホンダドリーム 磯子',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
          {
            shop_id: 466,
            id: 32,
            name: 'ホンダドリーム 横浜都筑',
            expenses_pdf: 'east-japan_designated-factory.pdf',
            expenses_image: 'east-japan_designated-factory.png',
          },
          {
            shop_id: 477,
            id: 33,
            name: 'ホンダドリーム 横浜旭',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
          {
            shop_id: 496,
            id: 38,
            name: 'ホンダドリーム 川崎宮前',
            expenses_pdf: 'east-japan_designated-factory.pdf',
            expenses_image: 'east-japan_designated-factory.png',
          },
          {
            shop_id: 487,
            id: 39,
            name: 'ホンダドリーム 横浜緑',
            expenses_pdf: 'east-japan_certified-factory.pdf',
            expenses_image: 'east-japan_certified-factory.png',
          },
        ],
      },
      {
        name: '中部エリア',
        all: '',
        allVal: '2all',
        shops: [
          {
            shop_id: 503,
            id: 90,
            name: 'ホンダドリーム 名古屋中央',
            expenses_pdf: 'chubu_certified-factory.pdf',
            expenses_image: 'chubu_certified-factory.png',
          },
          {
            shop_id: 515,
            id: 91,
            name: 'ホンダドリーム 名古屋南',
            expenses_pdf: 'chubu_certified-factory.pdf',
            expenses_image: 'chubu_certified-factory.png',
          },
          {
            shop_id: 520,
            id: 92,
            name: 'ホンダドリーム 小牧',
            expenses_pdf: 'chubu_designated-factory.pdf',
            expenses_image: 'chubu_designated-factory.png',
          },
          {
            shop_id: 529,
            id: 93,
            name: 'ホンダドリーム 名古屋東',
            expenses_pdf: 'chubu_certified-factory.pdf',
            expenses_image: 'chubu_certified-factory.png',
          },
          {
            shop_id: 540,
            id: 94,
            name: 'ホンダドリーム 一宮',
            expenses_pdf: 'chubu_certified-factory.pdf',
            expenses_image: 'chubu_certified-factory.png',
          },
          {
            shop_id: 677,
            id: 95,
            name: 'ホンダドリーム 豊橋',
            expenses_pdf: 'chubu_certified-factory.pdf',
            expenses_image: 'chubu_certified-factory.png',
          },
          {
            shop_id: 545,
            id: 96,
            name: 'ホンダドリーム 名古屋上小田井',
            expenses_pdf: 'chubu_certified-factory.pdf',
            expenses_image: 'chubu_certified-factory.png',
          },
          {
            shop_id: 555,
            id: 97,
            name: 'ホンダドリーム 岐阜',
            expenses_pdf: 'chubu_certified-factory.pdf',
            expenses_image: 'chubu_certified-factory.png',
          },
        ],
      },
      {
        name: '近畿エリア',
        all: '',
        allVal: '3all',
        shops: [
          {
            shop_id: 560,
            id: 124,
            name: 'ホンダドリーム 奈良',
            expenses_pdf: 'kinki-certified-factory.pdf',
            expenses_image: 'kinki-certified-factory.png',
          },
          {
            shop_id: 567,
            id: 125,
            name: 'ホンダドリーム 堺',
            expenses_pdf: 'kinki-certified-factory.pdf',
            expenses_image: 'kinki-certified-factory.png',
          },
          {
            shop_id: 571,
            id: 126,
            name: 'ホンダドリーム 神戸灘',
            expenses_pdf: 'kinki-certified-factory.pdf',
            expenses_image: 'kinki-certified-factory.png',
          },
          {
            shop_id: 575,
            id: 127,
            name: 'ホンダドリーム 箕面',
            expenses_pdf: 'kinki-certified-factory.pdf',
            expenses_image: 'kinki-certified-factory.png',
          },
          {
            shop_id: 579,
            id: 128,
            name: 'ホンダドリーム 藤井寺',
            expenses_pdf: 'kinki-certified-factory.pdf',
            expenses_image: 'kinki-certified-factory.png',
          },
          {
            shop_id: 583,
            id: 129,
            name: 'ホンダドリーム 京都伏見',
            expenses_pdf: 'kinki-certified-factory.pdf',
            expenses_image: 'kinki-certified-factory.png',
          },
          {
            shop_id: 587,
            id: 130,
            name: 'ホンダドリーム 尼崎',
            expenses_pdf: 'kinki-certified-factory.pdf',
            expenses_image: 'kinki-certified-factory.png',
          },
          {
            shop_id: 593,
            id: 131,
            name: 'ホンダドリーム 東淀川',
            expenses_pdf: 'kinki-certified-factory.pdf',
            expenses_image: 'kinki-certified-factory.png',
          },
          {
            shop_id: 598,
            id: 132,
            name: 'ホンダドリーム 豊中',
            expenses_pdf: 'kinki-certified-factory.pdf',
            expenses_image: 'kinki-certified-factory.png',
          },
          {
            shop_id: 602,
            id: 133,
            name: 'ホンダドリーム 京都右京',
            expenses_pdf: 'kinki-certified-factory.pdf',
            expenses_image: 'kinki-certified-factory.png',
          },
          {
            shop_id: 606,
            id: 134,
            name: 'ホンダドリーム 京都北山',
            expenses_pdf: 'kinki-certified-factory.pdf',
            expenses_image: 'kinki-certified-factory.png',
          },
          {
            shop_id: 610,
            id: 135,
            name: 'ホンダドリーム 姫路',
            expenses_pdf: 'kinki-certified-factory.pdf',
            expenses_image: 'kinki-certified-factory.png',
          },
          {
            shop_id: 3480,
            id: 175,
            name: 'ホンダドリーム 西宮甲子園',
            expenses_pdf: 'kinki-certified-factory.pdf',
            expenses_image: 'kinki-certified-factory.png',
          },
        ],
      },
      {
        name: '中国・四国エリア',
        all: '',
        allVal: '4all',
        shops: [
          {
            shop_id: 614,
            id: 138,
            name: 'ホンダドリーム 広島',
            expenses_pdf: 'chugoku-shikoku_designated-factory.pdf',
            expenses_image: 'chugoku-shikoku_designated-factory.png',
          },
          {
            shop_id: 618,
            id: 139,
            name: 'ホンダドリーム 福山',
            expenses_pdf: 'chugoku-shikoku_certified-factory.pdf',
            expenses_image: 'chugoku-shikoku_certified-factory.png',
          },
          {
            shop_id: 622,
            id: 140,
            name: 'ホンダドリーム 高松',
            expenses_pdf: 'chugoku-shikoku_certified-factory.pdf',
            expenses_image: 'chugoku-shikoku_certified-factory.png',
          },
          {
            shop_id: 626,
            id: 141,
            name: 'ホンダドリーム 岡山',
            expenses_pdf: 'chugoku-shikoku_designated-factory.pdf',
            expenses_image: 'chugoku-shikoku_designated-factory.png',
          },
          {
            shop_id: 630,
            id: 142,
            name: 'ホンダドリーム 高知',
            expenses_pdf: 'chugoku-shikoku_certified-factory.pdf',
            expenses_image: 'chugoku-shikoku_certified-factory.png',
          },
          {
            shop_id: 634,
            id: 143,
            name: 'ホンダドリーム 徳島',
            expenses_pdf: 'chugoku-shikoku_certified-factory.pdf',
            expenses_image: 'chugoku-shikoku_certified-factory.png',
          },
        ],
      },
      {
        name: '九州エリア',
        all: '',
        allVal: '5all',
        shops: [
          {
            shop_id: 638,
            id: 154,
            name: 'ホンダドリーム 熊本',
            expenses_pdf: 'kyushu_certified-factory.pdf',
            expenses_image: 'kyushu_certified-factory.png',
          },
          {
            shop_id: 652,
            id: 155,
            name: 'ホンダドリーム 博多',
            expenses_pdf: 'kyushu_certified-factory.pdf',
            expenses_image: 'kyushu_certified-factory.png',
          },
          {
            shop_id: 659,
            id: 156,
            name: 'ホンダドリーム 福岡東',
            expenses_pdf: 'kyushu_certified-factory.pdf',
            expenses_image: 'kyushu_certified-factory.png',
          },
          {
            shop_id: 663,
            id: 157,
            name: 'ホンダドリーム 久留米',
            expenses_pdf: 'kyushu_certified-factory.pdf',
            expenses_image: 'kyushu_certified-factory.png',
          },
          {
            shop_id: 667,
            id: 158,
            name: 'ホンダドリーム 福岡春日',
            expenses_pdf: 'kyushu_certified-factory.pdf',
            expenses_image: 'kyushu_certified-factory.png',
          },
          {
            shop_id: 672,
            id: 159,
            name: 'ホンダドリーム 福岡西',
            expenses_pdf: 'kyushu_certified-factory.pdf',
            expenses_image: 'kyushu_certified-factory.png',
          },
        ],
      },
    ],
  },
  // 予算選択肢
  PRICE_RANGE: [
    50000, 100000, 150000, 200000, 250000, 300000, 350000, 400000, 450000, 500000, 550000, 600000,
    650000, 700000, 750000, 800000, 850000, 900000, 950000, 1000000, 1100000, 1200000, 1300000,
    1400000, 1500000, 1600000, 1700000, 1800000, 1900000, 2000000, 2200000, 2400000, 2600000,
    2800000, 3000000, 3200000, 3400000, 3600000, 3800000, 4000000,
  ],
  // 新着表示期間 (日数)
  NEW_ARRIVAL_PERIOD: 10,

  // 見積もり用排気量
  ESTIMATE: {
    DISPLACEMENT: [
      { value: '50', label: '50cc以下', img: '50cc' },
      { value: '125', label: '51cc～125cc', img: '51cc' },
      { value: '250', label: '126cc～250cc', img: '126cc' },
      { value: '400', label: '251cc～400cc', img: '251cc' },
      { value: 'over', label: '401cc以上', img: '401cc' },
    ],
    COATING: [
      { label: 'ホイール', price: 5500 },
      { label: 'ヘルメット', price: 3850 },
      { label: 'メンテナンスセット', price: 3960 },
    ],
    OPTIONS: {
      color: { name: 'カラー', note: '' },
      pref: { name: '車両登録地域（お住まいの地域）を<br>選択してください。', note: '' },
      insurance: { name: '自賠責保険', note: '' },
      maintenance: { name: 'メンテナンスパック', note: '' },
      coating: { name: 'ガラスコーティング<small> (BIKE Aquly Premium EX)</small>', note: '' },
      recorder: {
        name: 'ドライブレコーダー<small> (デイトナ MIO MIVUE M820WD)</small>',
        note: '車種により「延長カメラケーブル」「本体・カメラ取付ステー」が別途必要になる場合がございます。',
      },
      etc: {
        name: 'ETC車載器',
        note: 'ETC車載器は、Honda 二輪ETC2.0車載器キット（アンテナ別体タイプ）になります。車種によりETCケースが別途必要になる場合がございます。',
      },
      extendedWarranty: { name: '延長保証', note: '' },
      loan: { name: '据置クレジット<small>(お支払い回数)</small>', note: '' },
      expenses: { name: '諸費用 <small>(自賠責保険を除く)</small>', note: '' },
    },
  },
  SEARCH_SORT: [
    {
      title: '予算順',
      value: [
        {
          label: '車両価格の安い順',
          value: 'price',
          direction: 'asc',
        },
        {
          label: '車両価格の高い順',
          value: 'price',
          direction: 'desc',
        },
      ],
    },
    {
      title: 'Web掲載順',
      value: [
        {
          label: 'Web掲載の新しい順',
          value: 'created',
          direction: 'desc',
        },
        {
          label: 'Web掲載の古い順',
          value: 'created',
          direction: 'asc',
        },
      ],
    },
    {
      title: '排気量順',
      value: [
        {
          label: '排気量の大きい順',
          value: 'displacement',
          direction: 'desc',
        },
        {
          label: '排気量の小さい順',
          value: 'displacement',
          direction: 'asc',
        },
      ],
    },
    {
      title: '走行距離順',
      value: [
        {
          label: '走行距離の長い順',
          value: 'ProductConditions.mileage',
          direction: 'desc',
        },
        {
          label: '走行距離の短い順',
          value: 'ProductConditions.mileage',
          direction: 'asc',
        },
      ],
    },
    {
      title: '総合評価順',
      value: [
        {
          label: '★数の多い順',
          value: 'ProductConditions.rating_total',
          direction: 'desc',
        },
        {
          label: '★数の少ない順',
          value: 'ProductConditions.rating_total',
          direction: 'asc',
        },
      ],
    },
  ],
}

export { Util }
